import { useCurrentOrganization } from './api/useOrganizations';
import {
  SubscriptionTier,
  canUseFeature,
  FEATURE_MIN_TIER,
} from '../lib/tiers';

/**
 * Returns the current organization's effective subscription tier (if loaded).
 *
 * Prefers the server-computed `effective_tier` so trial users transparently
 * get access to their trialled tier's features. Falls back to
 * `subscription_tier` for backwards compatibility with older API responses.
 *
 * Backed by the existing useCurrentOrganization query so we avoid
 * duplicate /organizations/current fetches.
 */
export function useSubscriptionTier(): SubscriptionTier | undefined {
  const { data } = useCurrentOrganization();
  return (data?.effective_tier ?? data?.subscription_tier) as
    | SubscriptionTier
    | undefined;
}

/**
 * Returns true if the current org can use the given feature based on tier.
 */
export function useCanUseFeature(feature: keyof typeof FEATURE_MIN_TIER): boolean {
  const tier = useSubscriptionTier();
  return canUseFeature(tier, feature);
}
